import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { State } from "../../../../state/store";
import { NotificationEmailContext } from "../../../provider/NotificationEmailProvider";
import { Loading } from "../../common/Loading";
import { AddEmailButton } from "./AddEmailButton";
import { EmailListItem } from "./EmailListItem";

export const EmailList = React.memo(function EmailList() {
    const { notificationEmailList } = useContext(NotificationEmailContext);

    const processing = useSelector((state: State) => state.user.processing);

    return processing > 0 ? (
        <Loading />
    ) : (
        <div className={"content"}>
            <ul className={"notification_email_list"}>
                {notificationEmailList.map((email, index) => <EmailListItem key={email.id} email={email} index={index} />)}
            </ul>
            <AddEmailButton />
        </div>
    );
});
